import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'

import { IconComponent } from '../../../sharedLegacy/components'

import './StreamingInfoPanelComponent.scss'

const StreamingInfoPanelComponent = ({
  quality,
  bitrate,
  server,
  streamName,
  fmleURL,
}) => {
  return (
    <div className="streaming-info-panel-component">
      <table>
        <thead>
          <tr>
            {/* eslint-disable jsx-a11y/control-has-associated-label */}
            <th>
              <FormattedMessage defaultMessage="Quality" />
            </th>
            <th>
              <FormattedMessage defaultMessage="Bitrate" />
            </th>
            <th>
              <FormattedMessage defaultMessage="Server" />
            </th>
            <th>
              <FormattedMessage defaultMessage="Stream" />
            </th>
            {/* eslint-enable jsx-a11y/control-has-associated-label */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{quality}</td>
            <td>{bitrate}</td>
            <td className="small-text">{server}</td>
            <td className="small-text stream-name">
              {streamName}
              <IconComponent
                name="download"
                size={[16, 16]}
                color="FFF"
                tooltip={intl.formatMessage({
                  defaultMessage: 'Download configuration',
                })}
                onClick={() => window.open(fmleURL)}
              />
              <IconComponent
                name="info"
                size={[16, 16]}
                color="FFF"
                onClick={() =>
                  window.open(
                    'https://www.twentythree.net/help/live/streaming-settings'
                  )
                }
                tooltip={intl.formatMessage({
                  defaultMessage: 'Get help',
                })}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

StreamingInfoPanelComponent.propTypes = {
  quality: PropTypes.string,
  bitrate: PropTypes.string,
  server: PropTypes.string,
  streamName: PropTypes.string,
  fmleURL: PropTypes.string,
}

export default StreamingInfoPanelComponent
